import { z } from 'zod';

export const connectionDTOSchema = z.object({
  id: z.string(),
  name: z.string(),
  strategy: z.string(),
  type: z.enum(['database', 'social']),
  enabled: z.boolean(),
});

export const connectionArrayDTOSchema = z.array(connectionDTOSchema);

export const connectionUpdateSchema = z.object({
  enabled: z.boolean(),
});
